import * as React from 'react'
import { useContext, useEffect, useState } from 'react'

import {AppContext} from "../../../Context/AppContext"

import {postier} from "./Postier"


export function Create({setPage}) {

    const { site, token, client, setLoading, siteList, setErrors } = useContext(AppContext)

    const [fields, setFields] = useState({ name: '', country: 'France', wheatherZipCode: '75000', zipCode: '75000'})

    const [idSite, setIdSite] = useState<string>('');

    const [pays, setPays] = useState([])

    const endLoading = (event:any) => {
        setLoading(false)
        setPage(event)
    }

    useEffect(() => {
        postier.getPays(setPays)
        
    }, [])

	
	useEffect(()=>{
		if (pays[0]){
			const fieldsCopy = {... fields}
			
			fieldsCopy["country"]="France"

			setFields(fieldsCopy)
			
		}

	},[pays])

    useEffect(() => {
        let final = ""       
        if (client) {
            // Check if is special client
            fetch('/data/clients').then(res => res.json()).then(data => {
                const list = data.filter(c => c.name === client.split(':')[0])
                if (list.length > 0){
                    const siteId = siteList ? siteList.length + 1 : 1
                    final = (siteId * 1000).toString()
                    setIdSite(final)
                    return 
                }
            })

            // If it is normal client
            const siteId = siteList ? siteList.length+1 : 1;
            const clientCode = client.split(":")[0];
            const clientNum = parseInt(clientCode.split(new RegExp('CC', 'i'))[1]);
            let splitter = '';
            const siteIdLength = siteId.toString().split('').length
            splitter = siteIdLength === 1 && '000' || siteIdLength === 2 && '00' || siteIdLength === 3 && '0'
            final = `${clientNum}${splitter}${siteId}`;
        } else {
            const siteId = 1;
            const clientCode = client.split(":")[0];
            const clientNum = parseInt(clientCode.split('CC')[1]);
            let splitter = '000';
            final = `${clientNum}${splitter}${siteId}`;
        }

        setIdSite(final)


    }, [site, client, siteList])

    const validate = () => {
        if (fields.name === "") {
            setErrors((errors: string[]) => [...errors, "Le nom du site ne peut pas être vide"])
            return;
        }
        const siteInfo = {
            Code: client.split(":")[0],
            ID: parseInt(idSite),
            Name: fields.name,
            Country: fields.country,
            WeatherZipCode: fields.wheatherZipCode,
            ZipCode: fields.zipCode,
            apiId: localStorage.getItem('apiId'),
            Database: client.split(':')[3]
        }

        setLoading(true)
        postier.createSite(token, siteInfo, endLoading, setErrors)
    }

    const handleChange = (field: string, e) => {
        const fieldsCopy = {...fields};
        fieldsCopy[field] = e.target.value;
        setFields(fieldsCopy);
    };

    return (
        <div className="site">
            <h2>Création site</h2>
            
                <label>Code</label>
                
                <div className="label"> { client.split(":")[0] }</div>

            
                <label>Site ID</label>
                
                <div className="label"> { idSite }</div>

            
                <label>Site </label>
                
                <input className="label" onChange={e => handleChange('name', e)} />

            
                <label>Pays</label>
                
                {/* <input className="label" onChange={e => handleChange('country', e)} /> */}
                <select className="label" value={fields.country} onChange={e => handleChange('country', e)}  >{pays[0]&&pays.map((p,i)=><option key={i} >{p.name}</option>)}</select>
            
                <label>Code postal météo</label>
                
                <input className="label" defaultValue={fields.wheatherZipCode} onChange={e => handleChange('wheatherZipCode', e)} />

            
                <label>Code postal</label>
                
                <input className="label" defaultValue={fields.zipCode} onChange={e => handleChange('zipCode', e)} />

            <button onClick={validate} >Enregistrer</button>
        </div>
    )
}
